import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InfoDialog from '../Dialog/InfoDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  infoCard: {
    cursor: 'pointer',
    width: '100%',
    padding: "24px 24px",
    display: 'flex',
    padding: "24px 16px 24px 24px",
    borderRadius: 8,
    border: "solid 2px #dcdcdc",
    backgroundColor: "#ffffff",
    boxShadow: 'none',
    height: 104,
    '&:hover': {
      backgroundColor: "#f1f3ff",
      border: 'solid 2px #8094ff'
    }
  },
  infoDetailsDiv: {
    paddingLeft: 16,
    display:'flex',
    flexDirection:'column'
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    color: "#0b1323",
    paddingBottom: 4,
    display: 'flex',
    alignItems: 'center'
  },
  infoText: {
    fontSize: 10,
    paddingBottom: 16
  },
  infoIcon: {
    "& .MuiSvgIcon-root": {
      width: 56,
      height: 56
    }
  },
  comingSoonDiv: {
    padding: '2px 12px',
    borderRadius: '4px',
    backgroundColor: '#ef8030',
    fontSize: '12px',
    fontWeight: 500,
    marginTop:-22,
    marginRight:-14,
    marginLeft: 'auto',
    color: 'white',
  }
}));
const TopCardIcon = (props) => {
  const {
    title,
    cardValue,
    color,
    infoIcon,
    infoTitle,
    infoText,
    icon,
    comingSoon
  } = props;
  const classes = useStyles();
  const [infoOpen, setInfoOpen] = React.useState(false);
  const handleInfoOpen = () => {
    setInfoOpen(true);
  }
  const handleInfoClose = () => {
    setInfoOpen(false);
  }
  return (
    <>

      <Paper className={classes.infoCard} >
        <div className={classes.infoIcon}>
          {icon}
        </div>
        <div className={classes.infoDetailsDiv}>
        {comingSoon &&
              <div className={classes.comingSoonDiv}>Coming Soon</div>
      }
          <div>
            <Typography className={classes.title}>
              {title}
            </Typography>
            <Typography className={classes.infoText} >{infoText}</Typography>
          </div>
        </div>
      </Paper>
    </>
  );
}
export default TopCardIcon;
